import { render, staticRenderFns } from "./ContactsListItem.vue?vue&type=template&id=5c5a707f&scoped=true&"
import script from "./ContactsListItem.vue?vue&type=script&lang=js&"
export * from "./ContactsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListItem.vue?vue&type=style&index=0&id=5c5a707f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a707f",
  null
  
)

export default component.exports